:host {
  display: block;
}

input {
  @include form-input;
}

select {
  @include form-select;
}

.form-field {
  @include form-field;
  margin-bottom: 10px;
  direction: var(--av-direction);
  label {
    @include form-label;
  }
}

.form-field-not-supported{
  background-color: var(--av-color-warning);
  color:  var(--av-color-warning-contrast);
  padding: 8px;
  border-radius: var(--av-border-radius-container);
}

.card-customer-header {
  font-weight: normal;
  margin-bottom: 10px;
  direction: var(--av-direction);
}

.actions {
  margin-top: 20px;
  text-align: right;
}

.text-muted {
  opacity: 0.6;
}
